<!-- page title -->
<h1>Store Management</h1>
<ng-container *ngIf="viewModel$ | async as viewModel">
    <form [formGroup]="filtersForm" novalidate>

        <!-- actions bar -->
        <div fxLayout="row" fxLayoutAlign="start center"  fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start start"  class="actions-bar toolbar">

            <button type="button" mat-raised-button color="accent" matTooltip="Add new record" [routerLink]="[0]"
                [queryParams]="{search: searchInput.value ? searchInput.value : null}">
                <fa-icon [icon]="['fas', 'plus']"></fa-icon>New Store
            </button>

            <button type="button"
            *ngIf="getSelectedSectionRecords() && getSelectedSectionRecords().length > 0"
            mat-raised-button [matMenuTriggerFor]="menu" matTooltip="Actions">
            <mat-icon>more_vert</mat-icon>Actions
          </button>
          <mat-menu #menu="matMenu">
            <button type="button" mat-menu-item [matMenuTriggerFor]="Download"><mat-icon>arrow_circle_down</mat-icon>Download</button>
            <button type="button" mat-menu-item (click)="deleteSelectedRecords()"><mat-icon>delete</mat-icon>Delete</button>
            <!-- <button type="button" mat-menu-item><mat-icon>file_copy</mat-icon>Copy</button>   -->
            <button type="button" mat-menu-item>
               {{ getSelectedSectionRecords().length }}
                Selected</button>           
          </mat-menu>
          <mat-menu #Download="matMenu">
            <button mat-menu-item (click)="downloadJSON()">JSON</button>
            <button mat-menu-item (click)="downloadCSV()">CSV</button>
          </mat-menu>

            <mat-form-field appearance="outline" class="mat-form-field-no-padding search-field">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput formControlName="search" type="text" (input)="onSearch($event)" placeholder="Search"
                    #searchInput />
                <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="searchInput.value"
                    (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <span class="menu-spacer" fxShow.lt-md="false"></span>

            <button #filterToggleButton mat-stroked-button type="button" matTooltip="Show/hide filters" (click)="filterSidenav.toggle()">
                <mat-icon>filter_alt</mat-icon>
            </button>
        </div>

        <mat-sidenav-container>
            <!--filter sidenav-->
            <mat-sidenav #filterSidenav mode="over" position="end">
                <mat-toolbar>
                    Filter
                    <span class="menu-spacer"></span>
                    <button type="button" mat-icon-button aria-label="Close filter menu" matTooltip="Close filter menu"
                        (click)="filterSidenav.toggle()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-toolbar>
                <div style="margin: 16px">
                    <div fxLayout="column">

                        <mat-form-field appearance="outline" fxFlex="auto">
                            <mat-label>City</mat-label>
                            <input matInput type="text" formControlName="city" [matAutocomplete]="auto" />
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let city of filteredCityNames$ | async" [value]="city">
                                    {{city}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        
                        <mat-form-field appearance="outline">
                            <mat-label>State</mat-label>
                            <mat-select multiple formControlName="state" (selectionChange)="onFilterChange($event)">
                                <mat-option *ngFor="let state of viewModel.states" [value]="state">{{state}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Division</mat-label>
                            <mat-select multiple formControlName="divisions" (selectionChange)="onFilterChange($event)">
                                <mat-option *ngFor="let division of viewModel.divisions" [value]="division">{{division.DivisionName}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>
                    <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="16px">
                        <button type="button"  mat-stroked-button matTooltip="Reset filters" (click)="resetFilters()">
                            Reset
                        </button>
                        <button type="button" mat-raised-button matTooltip="Apply filters" color="accent"
                            (click)="filterSidenav.toggle()" [disabled]="filtersForm.invalid">
                            Apply
                        </button>
                    </div>
                </div>
            </mat-sidenav>

            <div class="filter-chips" *ngIf="viewModel.filters.length > 0" fxLayout="row">
                <mat-chip-set aria-label="Selected filters">
                    <mat-chip *ngFor="let filter of viewModel.filters" (removed)="removeFilter(filter)">
                        {{filter.fieldName === 'divisions' ? filter.displayText : filter.value}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <button type="button"  class="filter_close_btn"  mat-flat-button matTooltip="Remove all filters" (click)="clearFilters()">
                    Clear all
                </button>
                </mat-chip-set>
                
            </div>

            <!--table view-->
            <table mat-table [dataSource]="viewModel.stores" matSort (matSortChange)="onSort($event)" matSortDisableClear [matSortStart]="'desc'"
                *ngIf="viewModel.stores.length">

                <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th class="no-ellipsis" mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </th>
                <td class="no-ellipsis" mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>

                <!-- Id Column -->
                <ng-container matColumnDef="Id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id" [resizeColumn]="true">
                        ID
                    </th>
                    <td mat-cell *matCellDef="let record">{{ record.Detail.Id }}</td>
                </ng-container>

                <!-- StoreName Column -->
                <ng-container matColumnDef="StoreName">
                    <th style="width:12%" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name" [resizeColumn]="true">
                        Name
                    </th>
                    <td mat-cell *matCellDef="let record"> {{ record.Detail.StoreName }}</td>
                </ng-container>

                <!-- DivisionName Column -->
                <ng-container matColumnDef="DivisionName">
                    <th style="width:12%" mat-header-cell *matHeaderCellDef [resizeColumn]="true">
                        Division
                    </th>
                    <td mat-cell *matCellDef="let record">{{ record.DivisionName }}</td>
                </ng-container>

                <!-- ClientKey Column -->
                <ng-container matColumnDef="ClientKey">
                    <th style="width:10%" mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by ClientKey" [resizeColumn]="true">
                        Client Key
                    </th>
                    <td mat-cell *matCellDef="let record">{{ record.Detail.ClientKey }}</td>
                </ng-container>

                <!-- Address1 Column -->
                <ng-container matColumnDef="Address1">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Address1" [resizeColumn]="true">
                        Address1
                    </th>
                    <td mat-cell *matCellDef="let record">{{ record.Detail.Address1 }}</td>
                </ng-container>

                <!-- City Column -->
                <ng-container matColumnDef="City">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by City" [resizeColumn]="true">
                        City
                    </th>
                    <td mat-cell *matCellDef="let record">{{ record.Detail.City }}</td>
                </ng-container>

                <!-- State Column -->
                <ng-container matColumnDef="State">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by State" [resizeColumn]="true">
                        State
                    </th>
                    <td mat-cell *matCellDef="let record">{{ record.Detail.State }}</td>
                </ng-container>

                <!-- PostalCode Column -->
                <ng-container matColumnDef="PostalCode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by PostalCode" [resizeColumn]="true">
                        Zip Code
                    </th>
                    <td mat-cell *matCellDef="let record">{{ record.Detail.PostalCode }}</td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="Actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let record">
                        <button type="button" mat-button color="accent" [routerLink]="[record.Detail.Id]">Edit</button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <table *ngIf="!viewModel.stores.length">
                <tr>
                    <td class="no-records" [attr.colspan]="displayedColumns.length">
                        <h2>No Records Found</h2>
                    </td>
                </tr>
            </table>

            <!-- pager -->
            <mat-paginator [length]="viewModel.totalRecords" [pageSize]="viewModel.page.pageSize"
                [pageSizeOptions]="[5, 10, 20, 50, 100,500]" (page)="onPage($event)" *ngIf="viewModel.stores.length"
                showFirstLastButtons [pageIndex]="viewModel.page.pageIndex">
            </mat-paginator>

        </mat-sidenav-container>
    </form>
</ng-container>

<ng-template #loading>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>
